export default __webpack_public_path__ + "static/UnleashedBrands-3045f0fc668ae89d446e8f2eb72f9d95.png";